/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Admin Users API
 * Admin bounded-context contract for user aggregate and owned task entity.
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Add a new task to a user. This is a convenience endpoint that creates
 * a task and associates it with the user.
 * @summary Add a task to a user
 */
export const addTaskBodyTitleMax = 255;

export const AddTaskBody = zod.object({
  title: zod.string().min(1).max(addTaskBodyTitleMax).describe("Task title"),
  status: zod.enum(["pending", "in-progress", "completed"]).describe("Task status"),
  dueAt: zod.iso.datetime({offset: true}).describe("Due date in ISO 8601 format"),
});

export const AddTaskResponse = zod.object({
  id: zod.string().describe("Unique task identifier"),
  title: zod.string().describe("Task title"),
  status: zod.enum(["pending", "in-progress", "completed"]).describe("Task status"),
  dueAt: zod.iso.datetime({offset: true}).describe("Due date in ISO 8601 format"),
});

/**
 * Update a task belonging to a user. Only specified fields are updated.
 * @summary Edit a task
 */
export const editTaskBodyTitleMax = 255;

export const EditTaskBody = zod.object({
  title: zod.string().min(1).max(editTaskBodyTitleMax).optional().describe("Task title"),
  status: zod.enum(["pending", "in-progress", "completed"]).optional().describe("Task status"),
  dueAt: zod.iso.datetime({offset: true}).optional().describe("Due date in ISO 8601 format"),
});

export const EditTaskResponse = zod.object({
  id: zod.string().describe("Unique task identifier"),
  title: zod.string().describe("Task title"),
  status: zod.enum(["pending", "in-progress", "completed"]).describe("Task status"),
  dueAt: zod.iso.datetime({offset: true}).describe("Due date in ISO 8601 format"),
});

/**
 * Delete a task belonging to a user.
 * @summary Remove a task from a user
 */
export const RemoveTaskResponse = zod.void();
